/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

const TotalHomeWifi = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--totalHomeWifi"
      {...props}
    >
      <path
        d="M7.65204 1.99374C7.86545 1.86332 8.1339 1.86332 8.34731 1.99374L13.014 4.84559C13.2121 4.96669 13.333 5.1822 13.333 5.41444V12.3333H14.5997C14.6434 12.1179 14.6663 11.895 14.6663 11.6667V5.41444C14.6663 4.71771 14.3038 4.07119 13.7092 3.70788L9.04257 0.856028C8.40235 0.46478 7.597 0.464779 6.95677 0.856028L2.29011 3.70788C1.6956 4.07119 1.33301 4.71771 1.33301 5.41444V11.6667C1.33301 11.895 1.35596 12.1179 1.39969 12.3333H2.66634V5.41444C2.66634 5.1822 2.7872 4.96669 2.98537 4.84559L7.65204 1.99374Z"
        fill="white"
      />
      <path
        d="M13.9999 13.6667H10.6663C10.6654 13.6667 10.6644 13.6667 10.6634 13.6667H5.66928L5.66634 13.6667H1.99944C2.60758 14.4763 3.5758 15 4.66634 15H11.333C12.4235 15 13.3918 14.4763 13.9999 13.6667Z"
        fill="white"
      />
      <path
        d="M3.49609 6.49669C4.50544 5.56746 5.85301 5 7.33312 5H8.66645C10.1466 5 11.4941 5.56746 12.5035 6.49669L11.7214 7.59337C10.9379 6.81458 9.8584 6.33333 8.66645 6.33333H7.33312C6.14117 6.33333 5.06163 6.81458 4.27818 7.59337L3.49609 6.49669Z"
        fill="white"
      />
      <path
        d="M10.8503 8.8148C10.2392 8.1114 9.33809 7.66666 8.33312 7.66666H7.66645C6.66148 7.66666 5.76038 8.1114 5.14924 8.8148L5.96154 9.95385C6.31344 9.38159 6.94538 9 7.66645 9H8.33312C9.05419 9 9.68613 9.38159 10.038 9.95385L10.8503 8.8148Z"
        fill="white"
      />
      <path
        d="M6.99967 11.3333C6.99967 10.781 7.44739 10.3333 7.99967 10.3333C8.55196 10.3333 8.99967 10.781 8.99967 11.3333C8.99967 11.8856 8.55196 12.3333 7.99967 12.3333C7.44739 12.3333 6.99967 11.8856 6.99967 11.3333Z"
        fill="white"
      />
    </svg>
  );
};

TotalHomeWifi.displayName = 'totalHomeWifi';

export default TotalHomeWifi;
